import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'

const LazyRendering = function ({
  className,
  threshold = 0.1,
  root = null,
  children,
}, ref) {
  const [isVisible, setIsVisible] = useState(false);
  const blockRef = useRef(null);

  useImperativeHandle(ref, () => ({
    isVisible,
    setIsVisible: () => setIsVisible(true),
  }), [isVisible, setIsVisible])

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing after first load
        }
      },
      {
        root,
        threshold,
      }
    );

    if (blockRef.current) {
      observer.observe(blockRef.current);
    }

    return () => {
      observer.disconnect()
    }; // Cleanup on unmount
  }, []);

  return (
    <div ref={blockRef} className={className}>
      { isVisible && children }
    </div>
  )
}

LazyRendering.propTypes = {
  children: PropTypes.any,
  threshold: PropTypes.number,
}

export default forwardRef(LazyRendering);
